import { getTicketCountOfTicketLines } from '../../utils/tickets/order-ticket-line-utils';
import { getOrderTickets } from './get-order-tickets';
/**
 * Returns the count of selected tickets, across all showtimes.
 */
export const getOrderTicketCount = () => {
    return getTicketCountOfTicketLines(getOrderTickets());
};
